package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class MagicLinkRequest(
    val email: String
)
